import Script from 'next/script';
import { type ReactElement } from 'react';
import { type BlogPosting, type ItemList, type WithContext } from 'schema-dts';

import { type ArticleCardData } from '@/app/components/client/article-card';

type Props = {
  articles: ArticleCardData[];
};

export const ArticleSeoScript = (props: Props): ReactElement => {
  const { articles } = props;

  // Consider using <script> if this ItemList is impactful to SEO
  const seoStructuredData: WithContext<ItemList> = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: articles.map(
      (article: ArticleCardData): BlogPosting => ({
        '@type': 'BlogPosting',
        author: [
          {
            '@type': 'Person',
            jobTitle: article.author.jobTitle,
            name: article.author.name,
          },
        ],
        dateModified: new Date(article.publicationDate).toISOString(),
        datePublished: new Date(article.publicationDate).toISOString(),
        headline: article.title,
        image: [article.coverImage?.responsiveImage?.src ?? ''],
      })
    ),
  };

  return (
    <Script
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(seoStructuredData),
      }}
      id="structured-data-article-list"
      strategy="lazyOnload"
      type="application/ld+json"
    />
  );
};
